import { render } from "./About.vue?vue&type=template&id=30d7075d"
const script = {}

import "./About.vue?vue&type=style&index=0&id=30d7075d&lang=css"

import exportComponent from "D:\\Dev\\Vue\\guesswhat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__